import React, { useEffect } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'

import { CBadge } from '@coreui/react'
import { getRolefromCookie, normalizeAppRole } from '../utils/handleCookie'

export const AppSidebarNav = ({ items }) => {
  const location = useLocation()

  const navLink = (name, icon, badge) => {
    return (
      <>
        {icon && icon}
        {name && name}
        {badge && (
          <CBadge color={badge.color} className="ms-auto">
            {badge.text}
          </CBadge>
        )}
      </>
    )
  }

  const navItem = (item, index) => {
    const { component, name, badge, icon, props, ...rest } = item

    let allRole = Array.isArray(rest.role) ? rest.role.map((item) => normalizeAppRole(item)) : rest.role
    let role = normalizeAppRole(getRolefromCookie())

    const Component = component

    if (allRole && allRole.includes(role)) {
      return (
        <Component
          {...(rest.to &&
            !rest.items && {
              component: NavLink,
            })}
          key={index}
          {...rest}
        >
          {navLink(name, icon, badge)}
        </Component>
      )
    } else {
      return <></>
    }
  }
  const navGroup = (item, index) => {
    const { component, name, icon, to, ...rest } = item
    
    let allRole = Array.isArray(rest.role) ? rest.role.map((r) => normalizeAppRole(r)) : rest.role
    let role = normalizeAppRole(getRolefromCookie())

    if (allRole && !allRole.includes(role)) {
      return <React.Fragment key={index}></React.Fragment>
    }

    const Component = component
    return (
      <Component idx={String(index)} key={index} toggler={navLink(name, icon)} visible={location.pathname.startsWith(to)} {...rest}>
        {item.items?.map((item, index) => (item.items ? navGroup(item, index) : navItem(item, index)))}
      </Component>
    )
  }

  return <React.Fragment>{items && items.map((item, index) => (item.items ? navGroup(item, index) : navItem(item, index)))}</React.Fragment>
}

AppSidebarNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
}

export default React.memo(AppSidebarNav)
